import { render, staticRenderFns } from "./AffiliateTab.vue?vue&type=template&id=0e0858df"
import script from "./AffiliateTab.vue?vue&type=script&lang=js"
export * from "./AffiliateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports